export default __webpack_public_path__ + "static/media/Ass_3.1674fb96.svg";